<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" fill="none" width="80" height="80">
    <circle cx="75" cy="75" fill="#E3F2FD" r="60"></circle>
    <path d="M52.5 30H90L112.5 52.5V120H52.5V30Z" fill="#FFFFFF" stroke="#1976D2" stroke-linejoin="round"
      stroke-width="1.5"></path>
    <path d="M90 30V52.5H112.5" stroke="#1976D2" stroke-linejoin="round" stroke-width="1.5"></path>
    <line stroke="#90CAF9" stroke-dasharray="2 4" stroke-linecap="round" stroke-width="1.5" x1="63.75" x2="101.25"
      y1="71.25" y2="71.25"></line>
    <line stroke="#90CAF9" stroke-dasharray="2 4" stroke-linecap="round" stroke-width="1.5" x1="63.75" x2="101.25"
      y1="86.25" y2="86.25"></line>
    <line stroke="#90CAF9" stroke-dasharray="2 4" stroke-linecap="round" stroke-width="1.5" x1="63.75" x2="82.5"
      y1="101.25" y2="101.25"></line>
    <g fill="none" stroke="#1976D2" stroke-width="1.875" opacity="0.9">
      <circle cx="105" cy="105" fill="#FFFFFF" r="18.75"></circle>
      <line stroke-linecap="round" stroke-width="3" x1="118.5" x2="131.25" y1="118.5" y2="131.25"></line>
      <line stroke-linecap="round" stroke-width="1.5" x1="99.75" x2="110.25" y1="99.75" y2="110.25"></line>
      <line stroke-linecap="round" stroke-width="1.5" x1="110.25" x2="99.75" y1="99.75" y2="110.25"></line>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
